function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_88",
  "data-name": "Gruppe 88",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_350",
  "data-name": "Pfad 350",
  d: "M96.48,294.7h4.7v7.224h-4.7v18.52H86.59V301.92H82.9V294.7H86.59v-1.163a19.733,19.733,0,0,1,.339-3.467,6.956,6.956,0,0,1,1.273-3.091,6.576,6.576,0,0,1,2.618-1.939,12.777,12.777,0,0,1,4.933-.739,67.217,67.217,0,0,1,7.539.606l-1.091,5.963a18.5,18.5,0,0,0-2.86-.291,3.181,3.181,0,0,0-1.915.449,2.476,2.476,0,0,0-.824,1.418A12.864,12.864,0,0,0,96.48,294.7Z",
  transform: "translate(-82.905 -284.297)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_351",
  "data-name": "Pfad 351",
  d: "M129.226,320.73a12.881,12.881,0,0,1,3.975-9.709q3.976-3.818,10.739-3.818,7.732,0,11.684,4.484a14.02,14.02,0,0,1-.764,18.629q-3.94,3.794-10.9,3.794-6.206,0-10.036-3.151A12.651,12.651,0,0,1,129.226,320.73Zm9.89-.024a7.765,7.765,0,0,0,1.394,5.091,4.568,4.568,0,0,0,7.006.024q1.369-1.624,1.37-5.212a7.59,7.59,0,0,0-1.382-4.982,4.3,4.3,0,0,0-3.418-1.636,4.469,4.469,0,0,0-3.563,1.66A7.686,7.686,0,0,0,139.116,320.705Z",
  transform: "translate(-109.373 -297.385)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_352",
  "data-name": "Pfad 352",
  d: "M199.447,308.56h11.708l4.085,7.176L220,308.56h10.884l-8.782,12.266,9.413,13.478H220l-4.763-8.29-5.588,8.29h-10.69l9.35-13.478Z",
  transform: "translate(-149.22 -298.161)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_353",
  "data-name": "Pfad 353",
  d: "M276.706,308.56h11.708l4.085,7.176,4.763-7.176h10.884l-8.782,12.266,9.412,13.478H297.262l-4.763-8.29-5.587,8.29h-10.69l9.35-13.478Z",
  transform: "translate(-193.365 -298.161)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_354",
  "data-name": "Pfad 354",
  d: "M386.753,334.3h-9.212v-4.169a13.575,13.575,0,0,1-4.157,3.661,11.065,11.065,0,0,1-5.151,1.09,8.388,8.388,0,0,1-6.387-2.436q-2.315-2.436-2.315-7.5V308.56h9.914v14.157a5.2,5.2,0,0,0,.9,3.442,3.181,3.181,0,0,0,2.521,1.018,3.6,3.6,0,0,0,2.9-1.357q1.128-1.357,1.127-4.872V308.56h9.866Z",
  transform: "translate(-240.968 -298.161)"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_355",
  "data-name": "Pfad 355",
  d: "M452.573,302.041s-1.947,10.941-6.215,13.715c-.536.348-.366,2.824.8,3.027,2.823.492,9.525-1.33,10.661,1.474,0,0,3.536,7.929,1.5,10.179,0,0-6.536,7.822-8.358,8.143,0,0-6.215,1.607-4.286,4.072,0,0,1.393,1.179,4.607-.429L467.039,329.9s3.536-3,3.643-.214l-.214,8.358,4.822,5.786s3.965.75,1.607-3.322a5.6,5.6,0,0,1-1.929-4.607v-8.036l7.072-2.143,10.394,4.607-2.572,7.286s-3.536,2.464-1.286,3.857a4.088,4.088,0,0,0,4.715-3.215s1.179-5.036,2.464-3.215c0,0,2.786,4.179,4.607,1.072l-2.786-4.179-.964-3.75-2.357-2.143.964-8.358,10.929,7.608s10.822,2.143,11.465-2.25-2.036-7.072-6.429-8.358a57.946,57.946,0,0,0-9.965-1.714l-5.358-.107s-9.322-5.465-19.394-1.286c0,0-7.715,2.464-11.251-1.714l-5.786-8.358s-2.893,4.286-4.715,2.679A12.993,12.993,0,0,1,452.573,302.041Z",
  transform: "translate(-290.415 -294.13)"
});

var SvgFoxxuLogo = function SvgFoxxuLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_89",
    "data-name": "Gruppe 89",
    width: 227.294,
    height: 49.754,
    viewBox: "0 0 227.294 49.754",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFoxxuLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/foxxu-logo.ba596eab.svg";
export { ForwardRef as ReactComponent };